<template>
  <div class="topmain">
    <div><van-nav-bar title="MCDEX时讯"></van-nav-bar></div>
    <div class="titlesubbig bottonline deptclass">科室分类：</div>
    <div class="contentscoll">
      <div v-for="(item,index) in data" :key="index" class="bottonline">
        <van-cell left :title="item.Clinic_name" is-link @click="Totitle(item.Clinicid,item.Clinic_name)"/>
      </div>    
    </div>
    <div style="height:0.5rem;width:100%;"></div>
    <!-- <Nav/> -->
     <van-tabbar active-color="#1989fa"  inactive-color="#000" route>
      <!-- <van-tabbar-item replace to="/home" icon="wap-home-o">首页</van-tabbar-item> -->
      <van-tabbar-item replace to="/" icon="apps-o">科室分类</van-tabbar-item>
      <van-tabbar-item replace to="/PublicTime" icon="clock-o">发布时间</van-tabbar-item>
      <van-tabbar-item replace to="/Search" icon="search">搜索</van-tabbar-item>    
      <van-tabbar-item replace to="/Scan" icon="scan">关于</van-tabbar-item>    
    </van-tabbar>
  </div>
</template>

<script>
import Nav from  './Nav'
export default {
  name: 'Dept',  
  components:{
      Nav
  },
  data () {
    return {
      data:[],
      active:1
    }
  },
  created(){
    this.GetDept();
  },
  methods:{ 
    // onClickLeft() {
    //   this.$router.go(-1);
    // },   
    GetDept() {
      this.$axios
        .get(window.apiUrl+"/pc/mcdex/GetallDept", {
          params: {}
        })
        .then(res => {
          if (res.data.Errs.length == 0) {
           this.data=res.data.Result;
          }
        });
    },
    Totitle(id,name){
      sessionStorage.setItem("Clinicid", id);
      sessionStorage.setItem("Clinic_name", name);
      this.$router.push({name: "DeptTitle"});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.deptclass{
  height: 0.34rem;
  line-height: 0.34rem;
  padding-left: 0.1rem;
  background: #F2EEEE;
}
</style>



// WEBPACK FOOTER //
// src/components/Dept.vue